
const util = require('util');

const _ = require('lodash');

const Bloodhound = require('corejs-typeahead/dist/bloodhound.js');


function toString (s) {
	return _.isUndefined(s) || s === null ? "" : String(s);
}

const customTokenizers = {
	nonwordRus: function (str) {
		return toString(str).split(/[^a-z0-9а-яё]/ig);
	},
};

_.each(customTokenizers, function (tokenizer, name) {
	Bloodhound.tokenizers[name] = tokenizer;
	Bloodhound.tokenizers.obj[name] = function (keys) {
		keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
		return function tokenize (obj) {
			return _.flatten(_.map(keys, function (k) {
				return tokenizer(toString(obj[k]));
			}));
		};
	};
});


function ExtendedBloodhound (options) {
	options = _.defaults({}, options, {
		queryTokenizer: Bloodhound.tokenizers.nonwordRus,
		datumTokenizer: Bloodhound.tokenizers.nonwrodRus,

		// This function will be called with suggestions
		// and can be used to filter/alter them arbitrarily.
		// You can also pass `{ sync: fn, async: fn }` here
		middleware: _.identity,

		// once character is sufficient to start searching
		sufficient: 1,
	});

	if (_.isString(options.identify)) {
		options.identify = _.property(options.identify);
	}

	const args = [].slice.call(arguments);
	args[0] = options;

	if (_.isFunction(options.middleware)) {
		this.middlewareSync = options.middleware;
		this.middlewareAsync = options.middleware;
	} else {
		this.middlewareSync = options.middleware.sync;
		this.middlewareAsync = options.middleware.async;
	}

	Bloodhound.apply(this, args);
}

util.inherits(ExtendedBloodhound, Bloodhound);

_.extend(ExtendedBloodhound.prototype, {
	search: function (query, sync, async) {
		sync = sync && _.flowRight(sync, this.middlewareSync);
		async = async && _.flowRight(async, this.middlewareAsync);
		return Bloodhound.prototype.search.call(this, query, sync, async);
	},
});

_.extend(ExtendedBloodhound, Bloodhound);

module.exports = ExtendedBloodhound;

